import { createApp } from '@app/adapters/create-app'
import type { VueElementConstructor } from 'vue'
import type { VueModalInstance } from '../types'

export const mountVueModalInstance = (
  Modal: VueElementConstructor,
  target: HTMLElement | undefined
): { instance: VueModalInstance; mountTarget: HTMLElement } => {
  const modalApp = createApp(
    Modal,
    {},
    {
      singletonId: 'modal-citizen-vue-modal',
    }
  )

  // Mount to a child div so that Vue's mount() doesn't replace the
  // target's innerHTML, which would destroy any portal modal content
  // teleported into the same element.
  const mountTarget = document.createElement('div')
  if (target) {
    target.appendChild(mountTarget)
  }

  return {
    instance: modalApp.mount(mountTarget) as VueModalInstance,
    mountTarget,
  }
}
